import { Question } from '../types/assessment';

export const socialSupportQuestions: Question[] = [
  {
    id: 'social_support_overall',
    text: 'Overall, how satisfied are you with the social support you receive?',
    type: 'scale',
    category: 'social-support',
    subcategory: 'overall',
    required: true,
    options: [
      { value: 1, label: '1 - Very dissatisfied', score: 1 },
      { value: 2, label: '2 - Dissatisfied', score: 2 },
      { value: 3, label: '3 - Neutral', score: 3 },
      { value: 4, label: '4 - Satisfied', score: 4 },
      { value: 5, label: '5 - Very satisfied', score: 5 }
    ]
  },
  {
    id: 'close_relationships',
    text: 'How many close friends or family members do you feel you can rely on?',
    type: 'multiple-choice',
    category: 'social-support',
    subcategory: 'close-relationships',
    required: true,
    options: [
      { value: 'none', label: 'None', score: 0 },
      { value: '1', label: '1 person', score: 1 },
      { value: '2-3', label: '2-3 people', score: 3 },
      { value: '4-6', label: '4-6 people', score: 4 },
      { value: 'more-than-6', label: 'More than 6 people', score: 4 }
    ]
  },
  {
    id: 'emotional_support',
    text: 'How often do you have someone to talk to about personal problems?',
    type: 'multiple-choice',
    category: 'social-support',
    subcategory: 'emotional',
    required: true,
    options: [
      { value: 'never', label: 'Never', score: 0 },
      { value: 'rarely', label: 'Rarely', score: 1 },
      { value: 'sometimes', label: 'Sometimes', score: 2 },
      { value: 'often', label: 'Often', score: 3 },
      { value: 'always', label: 'Always when needed', score: 4 }
    ]
  },
  {
    id: 'practical_support',
    text: 'If you needed help with daily tasks (like transportation, errands), how easily could you get it?',
    type: 'multiple-choice',
    category: 'social-support',
    subcategory: 'practical',
    required: true,
    options: [
      { value: 'very-difficult', label: 'Very difficult', score: 0 },
      { value: 'somewhat-difficult', label: 'Somewhat difficult', score: 1 },
      { value: 'neutral', label: 'Neutral', score: 2 },
      { value: 'somewhat-easy', label: 'Somewhat easy', score: 3 },
      { value: 'very-easy', label: 'Very easy', score: 4 }
    ]
  },
  {
    id: 'loneliness_frequency',
    text: 'How often do you feel lonely?',
    type: 'multiple-choice',
    category: 'social-support',
    subcategory: 'loneliness',
    required: true,
    options: [
      { value: 'never', label: 'Never', score: 4 },
      { value: 'rarely', label: 'Rarely', score: 3 },
      { value: 'sometimes', label: 'Sometimes', score: 2 },
      { value: 'often', label: 'Often', score: 1 },
      { value: 'always', label: 'Almost always', score: 0 }
    ]
  },
  {
    id: 'social_activities',
    text: 'How often do you participate in social activities?',
    type: 'multiple-choice',
    category: 'social-support',
    subcategory: 'activities',
    required: true,
    options: [
      { value: 'daily', label: 'Daily', score: 4 },
      { value: 'few-times-week', label: 'A few times a week', score: 3 },
      { value: 'weekly', label: 'About once a week', score: 2 },
      { value: 'monthly', label: 'About once a month', score: 1 },
      { value: 'rarely', label: 'Rarely or never', score: 0 }
    ]
  },
  {
    id: 'relationship_quality',
    text: 'How would you describe the quality of your closest relationships?',
    type: 'multiple-choice',
    category: 'social-support',
    subcategory: 'relationship-quality',
    required: true,
    options: [
      { value: 'excellent', label: 'Excellent - very supportive and healthy', score: 4 },
      { value: 'good', label: 'Good - mostly supportive', score: 3 },
      { value: 'fair', label: 'Fair - some ups and downs', score: 2 },
      { value: 'poor', label: 'Poor - often stressful or conflicted', score: 1 },
      { value: 'very-poor', label: 'Very poor - mostly harmful or toxic', score: 0 }
    ]
  },
  {
    id: 'social_barriers',
    text: 'What barriers prevent you from having the social support you want? (Select all that apply)',
    type: 'multi-select',
    category: 'social-support',
    subcategory: 'barriers',
    required: false,
    options: [
      { value: 'social-anxiety', label: 'Social anxiety or shyness' },
      { value: 'geographic-isolation', label: 'Geographic isolation' },
      { value: 'time-constraints', label: 'Time constraints' },
      { value: 'financial-constraints', label: 'Financial constraints' },
      { value: 'health-problems', label: 'Health problems or disability' },
      { value: 'trust-issues', label: 'Difficulty trusting others' },
      { value: 'past-trauma', label: 'Past relationship trauma' },
      { value: 'family-obligations', label: 'Family caregiving obligations' },
      { value: 'work-demands', label: 'Work demands' },
      { value: 'language-barriers', label: 'Language or cultural barriers' },
      { value: 'no-barriers', label: 'No significant barriers' },
      { value: 'prefer-solitude', label: 'I prefer being alone' }
    ]
  },
  {
    id: 'family_relationships',
    text: 'How would you describe your relationships with family members?',
    type: 'multiple-choice',
    category: 'social-support',
    subcategory: 'family',
    required: true,
    options: [
      { value: 'very-close', label: 'Very close and supportive' },
      { value: 'somewhat-close', label: 'Somewhat close' },
      { value: 'neutral', label: 'Neutral or distant' },
      { value: 'strained', label: 'Strained or difficult' },
      { value: 'no-contact', label: 'Little to no contact' },
      { value: 'no-family', label: 'No living family members' }
    ]
  },
  {
    id: 'romantic_relationship',
    text: 'If you are in a romantic relationship, how satisfied are you with it?',
    type: 'multiple-choice',
    category: 'social-support',
    subcategory: 'romantic',
    required: false,
    condition: {
      dependsOn: 'demo_relationship_status',
      operator: 'includes',
      value: ['dating', 'married', 'domestic-partnership']
    },
    options: [
      { value: 'very-satisfied', label: 'Very satisfied', score: 4 },
      { value: 'satisfied', label: 'Satisfied', score: 3 },
      { value: 'neutral', label: 'Neutral', score: 2 },
      { value: 'dissatisfied', label: 'Dissatisfied', score: 1 },
      { value: 'very-dissatisfied', label: 'Very dissatisfied', score: 0 }
    ]
  },
  {
    id: 'social_confidence',
    text: 'How confident do you feel in social situations?',
    type: 'multiple-choice',
    category: 'social-support',
    subcategory: 'confidence',
    required: true,
    options: [
      { value: 'very-confident', label: 'Very confident', score: 4 },
      { value: 'somewhat-confident', label: 'Somewhat confident', score: 3 },
      { value: 'neutral', label: 'Neutral', score: 2 },
      { value: 'somewhat-anxious', label: 'Somewhat anxious', score: 1 },
      { value: 'very-anxious', label: 'Very anxious', score: 0 }
    ]
  }
]; 